import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
import Uid2Token from "@/lib/uid2Token";
export const typeDef = gql`
  type HowtoPlay @cacheControl(maxAge: 60) {
    id: ID!
    free: Boolean
    member_only: Boolean
    rights: [Right]
    courses: [Course]
    products: [Product]
  }

  type Uid2Token {
    token: String
  }

  type Query {
    howtoPlay(id: Int): HowtoPlay
    uid2Token: Uid2Token
  }
`;
export const resolvers = {
  Query: {
    howtoPlay: async (_parent, _ref, _ref2) => {
      let {
        id
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        // 権利がたくさん紐づいているチャンネルのIDを指定されるとAPI側が落ちるのでエピソードかどうか確認する
        const res = await dataSources.episodes.getEpisode(id);
        const meta = res.metas[0];
        if (!meta) {
          throw new Error(`not episode meta. ID: ${id}`);
        }
        const howtoplay = await dataSources.meta.howtoPlay(id);
        const courses = howtoplay.courses;
        const rightIds = [];
        courses === null || courses === void 0 || courses.forEach(e => {
          const value = e === null || e === void 0 ? void 0 : e.ref_id;
          if (value) {
            rightIds.push(`ref:${value}`);
          }
        });
        return _objectSpread({
          id
        }, howtoplay);
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    uid2Token: async (_parent, _args, _ref3) => {
      let {
        req,
        res
      } = _ref3;
      const uid2 = new Uid2Token(req, res);
      try {
        const token = await uid2.getToken();
        return {
          token
        };
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  }
};